import React from 'react';

function ContactConfirmation() {
    return (
        <div>
            <h2>Thank You!</h2>
            <p>I've received your message and will get back to you as soon as I can.</p>
        </div>
    )

}

export default ContactConfirmation;